import * as ProductActions from "./productActions";

export default ProductActions;



// WEBPACK FOOTER //
// ./src/actions/ProductActions/index.js